<script>
  import { setLocalStorage } from './utils';
  import FaRegSave from 'svelte-icons/fa/FaRegSave.svelte';
  import FaCheck from 'svelte-icons/fa/FaCheck.svelte';

  export let markdownValue;
  let isSaved = false;

  const handleSave = () => {
    setLocalStorage(markdownValue);
    isSaved = true
  };

  const handleInput = () => {
    if (isSaved) isSaved = false;
  }
</script>

<div class="markdown-app__editor-col">
  <button on:click={handleSave}>
      {#if isSaved}
      <FaCheck />
      {:else}
      <FaRegSave />
      {/if}
  </button>
  <textarea bind:value={markdownValue} on:input="{handleInput}" class="markdown-app__textarea"></textarea>
  
</div>

<style>
  .markdown-app__editor-col {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #f3f3f3;
    grid-column: 1;
    padding: 0 20px;
    height: 100%;
  }

	.markdown-app__textarea {
    border: none;
    resize: none;
    width: 100%;
    height: 100%;
    background-color: #1C1E26;
  	color: #B3BBBB;
  }

  .markdown-app__textarea:focus {
    outline: none;
  }
</style>